import { Component, Inject, OnInit } from '@angular/core';
import { ProductosFinancierosService } from '../../../services/productos-financieros.service';
import { DatesHelpersService } from '../../../services/tools/dates-helpers.service';
import { HelpersService } from '../../../services/tools/helpers.service';
import { MatDialog, MatDialogRef, MatRadioChange, MAT_DIALOG_DATA } from '@angular/material';
import { EsquemaInversionService } from '../../../services/esquema-inversion.service';
import { SimulacionModalComponent } from '../simulacion-esquema-inversion/simulacion-modal/simulacion-modal.component';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { SocioFondeadorService } from '../../../services/socio-fondeador.service';
import { ConstantsService } from '../../../services/constants.service';
declare var $;

@Component({
  selector: 'app-esquema-inversion-modal',
  templateUrl: './esquema-inversion-modal.component.html',
  styleUrls: ['./esquema-inversion-modal.component.scss']
})
export class EsquemaInversionModalComponent implements OnInit {

  public isUpdate: boolean = false;
  public errors:any = {};
  public fecha_inicio_inversion: string = null;
  public processing: boolean = false;
  //Variable del ngModel del form para fondeador
  public esquema_inversion: any = {};
  //Productos financieros
  public producto_financiero: any = {id:null};
  public productosOpc: any[] = [];
  public productoPorDefecto: string = "";
  public fechaFin_inversion: string = "";
  public fechaTemp: any = null;
  //Capitalización
  public opcCapitalizacion: string = "";
  public opcRetencionImpuestos: string = "";
  public isRetencionImpuestos:boolean = false;
  //Para simulación
  public esquemaInversion: any = { monto: 500000, tasa: 8, plazo: 360};
  public simulacion:boolean = false;

  //Banderas tipo fondeador
  public esInversionista:boolean = true;
  public esAhorrador:boolean = false;
  //Para ahorrador simulación
  public simulacionAhorrador:boolean=false;
  public inversion_ahorrador: any = {};

  public idFondeador : number = 0;
  public fondeador : any = {};
  public isLoading:boolean = false;
  //Tipos de fondeador
  public tiposFondeador: string[] = ['ahorrador', 'inversionista'];
  public tipo_fondeador: string = "";
  //Retiros
  public retiro_saldo : any [];
  public tieneRetiros: boolean = false;

  constructor(
    private datesHelper : DatesHelpersService,
    private helperService: HelpersService,
    private esquemaService: EsquemaInversionService,
    private productosService: ProductosFinancierosService,
    private fondeadoresService: FondeadoresService,
    public socioFondeadorService: SocioFondeadorService,
    public dialogRef: MatDialogRef<EsquemaInversionModalComponent>,
    public dialog: MatDialog,
    @Inject (MAT_DIALOG_DATA) public data: any,
    private api:ConstantsService,
  ) { }

  ngOnInit() {
    this.esquema_inversion = this.esquemaService.getDefaultSchedule();
    this.idFondeador = this.data.idFondeador;
    this.obtFondeadorId(this.idFondeador);
    // if(this.data.fondeador.tipo_fondeador == "ahorrador"){
    //   this.esAhorrador = true;
    //   this.esInversionista=false;
    // }else if(this.data.fondeador.tipo_fondeador == "inversionista"){
    //   this.esInversionista=true;
    //   this.esAhorrador=false;
    // }

    this.getProductosFinancieros();
    
  }

  //Obtener fondeador por ID
  public obtFondeadorId(id:number){
    this.isLoading = true;
    this.fondeadoresService.getFondeadorById(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.fondeador = jsonResult.content[0];
          console.log("Fondeador ID: ", this.fondeador);
          this.getRetirosSaldo(id);
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener retiros de saldo del fondeador seleccionado
  public getRetirosSaldo(id){
    this.isLoading = true;
    this.socioFondeadorService.getRetirosSaldoId(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.retiro_saldo = jsonResult.content;
         
          if(this.retiro_saldo.length > 0){
            console.log("RetirosSaldo: ", this.retiro_saldo);
            //Actualizar saldo disponible si es que tiene retiros pendientes
            for (let index = 0; index < this.retiro_saldo.length; index++) {
              const retiro = this.retiro_saldo[index];
              if (retiro.estatus == 0){
                this.tieneRetiros = true;
                this.fondeador.saldo_disponible = (this.fondeador.saldo_disponible - retiro.monto_saldo);
              }
            }
            //this.retiro_saldo.forEach(retiro => {
            //});
          }else{
            this.tieneRetiros = false;
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

   //Validar form del fondeador
   public accept(flag) {
    this.errors = [];
    
    //Fecha de inicio de inversión
    if(this.esquema_inversion.fecha_inicio_inversion === "" ){
      this.esquema_inversion.fecha_fin_inversion = "";
    }
    //idFondeador
    if(this.data.idFondeador === null){
      this.esquema_inversion.idFondeador = "";
    }else{
      this.esquema_inversion.idFondeador = this.data.idFondeador;
    }
    //Producto financiero
    if(this.producto_financiero.id === null){
      this.esquema_inversion.idProductoFinanciero = "";
    }
    else
    {
      this.esquema_inversion.idProductoFinanciero = this.producto_financiero.id;
    }

    //Capitalización
    if(this.opcCapitalizacion.length < 1){
      this.esquema_inversion.capitalizacion = "";
    }
    else
    {
      this.esquema_inversion.capitalizacion = this.opcCapitalizacion;
    }
    //Verificar el tipo de fondeador
    if(this.esquema_inversion.tipo_producto === "inversionista"){
      //Retención de impuestos
      if(this.opcRetencionImpuestos.length < 1){
        this.esquema_inversion.retencion_impuestos = "";
      }
      else
      {
        this.esquema_inversion.retencion_impuestos = this.opcRetencionImpuestos;
      }
    }else if(this.esquema_inversion.tipo_producto === "ahorrador"){
      //this.esquema_inversion.capitalizacion = 2;
      this.esquema_inversion.retencion_impuestos = "no";
    }
    
    //Agregar null si no tiene tasa de retención
    if(this.esquema_inversion.tasa_retencion === "" ){
      this.esquema_inversion.tasa_retencion = null;
    }else if(this.esquema_inversion.retencion_impuestos === "no"){
      this.esquema_inversion.tasa_retencion = null;
    }

    //Funcion para validar campos
    this.errors = this.esquemaService.validate(this.esquema_inversion);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos Esquema: ", this.esquema_inversion);
    this.processing = true;
    
    //this.registrarEsquemaInversion();
    this.simulacion=flag;
    if(this.simulacion){
      if(this.esquema_inversion.tipo_producto === "inversionista"){
        //this.esquemaInversion.monto = parseInt(this.esquema_inversion.monto);
        this.esquema_inversion.plazo = this.producto_financiero.plazo;
        this.esquema_inversion.tasa_interes = this.producto_financiero.tasa;
        this.esquema_inversion.nombre_producto = this.producto_financiero.nombre;
        this.esquema_inversion.penalizacion = this.producto_financiero.penalizacion;
        this.esquema_inversion.tipo_fondeador = this.esquema_inversion.tipo_producto;
        this.simulacion = true;
        //console.log("Datos simulación", this.esquemaInversion);
        //Abrimos el modal
        const dialogRef = this.dialog.open(SimulacionModalComponent, {
          // height: '80vh',
          // width: '60vw',
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '80%',
          data: {esquema: this.esquema_inversion, modal:true, tipo: "inversionista" }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if(result.cerrar){
            this.simulacion = false;
          }
        });
      }else if(this.esquema_inversion.tipo_producto === "ahorrador"){
        this.simulacionAhorrador = true;
        //Armar nuevo json
        this.inversion_ahorrador.fecha_inicio_inversion = this.esquema_inversion.fecha_inicio_inversion;
        this.inversion_ahorrador.fecha_fin_inversion = this.esquema_inversion.fecha_fin_inversion;
        this.inversion_ahorrador.monto = this.esquema_inversion.monto;
        this.inversion_ahorrador.tipo_fondeador = this.esquema_inversion.tipo_producto;
        this.inversion_ahorrador.tasa_interes = this.producto_financiero.tasa;
        this.inversion_ahorrador.periodicidad = this.producto_financiero.periodicidad;
        this.inversion_ahorrador.iva = this.producto_financiero.iva;
        this.inversion_ahorrador.plazo = this.producto_financiero.plazo;
        this.inversion_ahorrador.capitalizacion = this.esquema_inversion.capitalizacion;
  
  
        console.log("Esquema Ahorrador Simulación: ", this.inversion_ahorrador);
        
        const dialogRef = this.dialog.open(SimulacionModalComponent, {
          // height: '80vh',
          // width: '60vw',
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '80%',
          data: {esquema_ahorrador: this.inversion_ahorrador, modal:true, tipo: "ahorrador" }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if(result.cerrar){
            this.simulacionAhorrador = false;
          }
        });
      }
    }else{
      console.log("Datos Esquema a registrar: ", this.esquema_inversion);
      this.processing = true;
      
      this.registrarEsquemaInversion();
    }
    
  }
  //Agregar nuevo esquema de inversión al fondeador seleccionado
  public registrarEsquemaInversion(){
    this.esquemaService.registrarEsquema(this.esquema_inversion)
     .subscribe(response => {
       const datosEsquema = response.json();

       console.log("Resp service esquema: ",datosEsquema);

       this.processing = false;
       if (datosEsquema.success) {
        console.log(datosEsquema);
        this.helperService.notification('Esquema agregado', 'Se ha agrado exitosamente el nuevo esquema de inversión', 'success');
        window.open(this.api.apiURL+"/profinbox/esquemarecibo?idFondeador="+datosEsquema.content.idFondeador,"__blank")
        this.dialogRef.close({update:true});
        //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
     });
  }
  public close(){
    this.dialogRef.close({update:false})
  }

  //Obtener productos financieros
  private getProductosFinancieros(page = null){
    this.productosService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json().content;
        if(jsonResult){
          this.productosOpc = jsonResult;
          this.productosOpc.forEach((producto, index) => {
            var rangoMin = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_min);
            var rangoMax = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_max);
            var cadena = producto.nombre+" / "+rangoMin+" a "+rangoMax+" / "+"P. "+producto.plazo+" días";
            this.productosOpc[index].cadena = cadena;            
          });
          //this.productosOpc = jsonResult;
          console.log("Los productos: ", this.productosOpc);
          if (this.productosOpc.length>1){
            this.productoPorDefecto = "Seleccione";
          } else if(this.productosOpc.length>0){
            this.producto_financiero =  this.productosOpc[0];
          }
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener productos financieros por tipo de fondeador
  private getProductosFinancierosTipo(){
    this.productosService.getSelectTipo(this.tipo_fondeador).subscribe(
      (response)=>
      {
        const jsonResult = response.json().content;
        if(jsonResult){
          this.productosOpc = jsonResult;
          this.productosOpc.forEach((producto, index) => {
            var rangoMin = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_min);
            var rangoMax = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_max);
            var cadena = producto.nombre+" / "+rangoMin+" a "+rangoMax+" / "+"P. "+producto.plazo+" días";
            this.productosOpc[index].cadena = cadena;            
          });
          //this.productosOpc = jsonResult;
          console.log("Los productos: ", this.productosOpc);
          if (this.productosOpc.length>1){
            this.productoPorDefecto = "Seleccione";
          } else if(this.productosOpc.length>0){
            this.producto_financiero =  this.productosOpc[0];
          }
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Saber que esquema de inversión ha sido seleccionado
  public productoFinancieroChanged(producto){
    
    if(producto.nombre){
      //En caso de que sea socio
      if(this.fondeador.idSocio != null){
        this.producto_financiero = producto;
        if(this.fondeador.saldo_disponible < this.producto_financiero.rango_monto_min){
          alert("No cuenta con saldo suficiente para invertir");
          this.close();
        }
        //Validar rangos
        this.esquema_inversion.monto = this.producto_financiero.rango_monto_min;
        //Agregamos el monto, la tasa y el plazo
        this.esquemaInversion.tasa = this.producto_financiero.tasa;
        this.esquemaInversion.plazo = this.producto_financiero.plazo;
        //Cuando cambia el select asigna la fecha final de inversión
        if(this.esquema_inversion.fecha_inicio_inversion === "" ){
          this.esquema_inversion.fecha_fin_inversion = "";
        }else{
          this.fechaTemp = new Date(this.esquema_inversion.fecha_inicio_inversion.replace(/-/g, '\/'));
          console.log("FechaInit: ", this.fechaTemp);
          this.fechaTemp.setDate(this.fechaTemp.getDate()+this.producto_financiero.plazo);
          this.fechaTemp = this.fechaTemp.toISOString();
          //Separamos la fecha
          var f = this.fechaTemp.split("T")[0];
          this.esquema_inversion.fecha_fin_inversion = f;
          console.log("Fond_fecha: ", this.esquema_inversion.fecha_fin_inversion);
        }
      }else{
        //Si es un fondeador normal
        this.producto_financiero = producto;
        //Validar rangos
        this.esquema_inversion.monto = this.producto_financiero.rango_monto_min;
        //Agregamos el monto, la tasa y el plazo
        this.esquemaInversion.tasa = this.producto_financiero.tasa;
        this.esquemaInversion.plazo = this.producto_financiero.plazo;
        //Cuando cambia el select asigna la fecha final de inversión
        if(this.esquema_inversion.fecha_inicio_inversion === "" ){
          this.esquema_inversion.fecha_fin_inversion = "";
        }else{
          this.fechaTemp = new Date(this.esquema_inversion.fecha_inicio_inversion.replace(/-/g, '\/'));
          console.log("FechaInit: ", this.fechaTemp);
          this.fechaTemp.setDate(this.fechaTemp.getDate()+this.producto_financiero.plazo);
          this.fechaTemp = this.fechaTemp.toISOString();
          //Separamos la fecha
          var f = this.fechaTemp.split("T")[0];
          this.esquema_inversion.fecha_fin_inversion = f;
          console.log("Fond_fecha: ", this.esquema_inversion.fecha_fin_inversion);
        }
      }
    }else{
      this.esquema_inversion.fecha_fin_inversion = "";
    }
  }

  public actualizarEsquema(){
    if(this.producto_financiero.nombre != ""){
      console.log("Monto: ", this.esquema_inversion.monto);
      
      //Validar rango
      if(Number(this.esquema_inversion.monto) > this.producto_financiero.rango_monto_max){
        alert("Ha excedido el monto del esquema de inversión");
        this.esquemaInversion.monto = this.producto_financiero.rango_monto_max;
      }
      if(Number(this.esquema_inversion.monto) < this.producto_financiero.rango_monto_min){
        alert("La cantidad no corresponde al mínimo de inversión");
        this.esquema_inversion.monto = this.producto_financiero.rango_monto_min;
      }
      //Esto lo hace solo si es un socio
      if(this.fondeador.idSocio != null){
        if(Number(this.esquema_inversion.monto) > this.fondeador.saldo_disponible.toFixed(2)){
          alert("No cuenta con saldo suficiente para invertir esa cantidad");
          console.log(this.fondeador.saldo_disponible)
          console.log(this.esquema_inversion.monto)
          console.log(this.fondeador.saldo_disponible.toFixed(2))
          this.esquema_inversion.monto = this.fondeador.saldo_disponible;
        }
      }
      //Validar fechas
      if(this.esquema_inversion.fecha_inicio_inversion === "" || this.esquema_inversion.monto === ""){
        this.esquema_inversion.fecha_fin_inversion = "";
      }else{
        this.fechaTemp = new Date(this.esquema_inversion.fecha_inicio_inversion.replace(/-/g, '\/'));
        console.log("FechaInit: ", this.fechaTemp);
        this.fechaTemp.setDate(this.fechaTemp.getDate()+this.producto_financiero.plazo);
        this.fechaTemp = this.fechaTemp.toISOString();
        //Separamos la fecha
        var f = this.fechaTemp.split("T")[0];
        this.esquema_inversion.fecha_fin_inversion = f;
      }
    }else{
      this.esquema_inversion.fecha_fin_inversion = "";
    }
  }

  public getCapitalizacion(){
    console.log("Capitalizacion: ", this.opcCapitalizacion);
    
  }
  public getRetencionImpuestos(){
    if(this.opcRetencionImpuestos === "si")
      this.isRetencionImpuestos = true;
    else
      this.isRetencionImpuestos = false;

    console.log("Retencion_impuestos: ", this.opcRetencionImpuestos);
    
  }

  public limpiarEsquema(){
    this.esquema_inversion.monto = "";
    this.esquema_inversion.fecha_inicio_inversion ="";
    this.esquema_inversion.fecha_fin_inversion ="";
  }

  public radioChange($event: MatRadioChange) {
    console.log($event.source.name, $event.value);

    if ($event.value === 'ahorrador') {
      this.esquema_inversion.tipo_producto = "ahorrador";
      this.esAhorrador = true;
      this.tipo_fondeador = "Ahorrador";
      this.limpiarEsquema();
      this.esInversionista = false;
      //this.tipoInversionista = false;
      this.simulacion = false;
      this.simulacionAhorrador = false;
      this.getProductosFinancierosTipo();
    }else if($event.value === 'inversionista'){
      this.esquema_inversion.tipo_producto = "inversionista";
      this.simulacionAhorrador = false;
      this.simulacion = false;
      this.limpiarEsquema();
      this.esAhorrador = false;
      //this.tipoInversionista = true;
      this.tipo_fondeador = "Inversionista";
      this.esInversionista = true;
      this.getProductosFinancierosTipo();
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/esquema-inversion-modal/esquema-inversion-modal.component.ts